import { TSearchValue } from "@src/components/intelligence-search/search-template";
import { SmlAsset, SmlJsonQueryFilter } from "@src/types/intelligence-search";

export const convertQueryFilterToSearchValues = (
    filters: SmlJsonQueryFilter[],
    onShowClear?: (item: SmlJsonQueryFilter) => boolean,
): TSearchValue[] => {
    const mappingFilterToValues = filters.reduce((acc, curr) => {
        if (!curr.meta) return acc;
        const isMemberFilter = !!curr.operator;
        const preAcc = acc[curr.meta.name] ?? {
            isCustomMetric: curr.isCustomMetric,
            showClear: onShowClear?.(curr) ?? true,
        };

        if (isMemberFilter) {
            acc[curr.meta.name] = {
                ...preAcc,
                meta: curr.meta as SmlAsset,
                filter: {
                    name: curr.meta.name,
                    operator: curr.operator,
                    value: curr.values,
                },
            };
        } else {
            acc[curr.meta.name] = {
                ...preAcc,
                name: curr.meta.name,
                meta: curr.meta as SmlAsset,
            };
        }
        return acc;
    }, {} as Record<string, TSearchValue>);
    return Object.values(mappingFilterToValues);
};
